<template>
  <div class="auth-page">
    <div class="auth-card">
      <div class="auth-card-title">{{ lang.title }}</div>
      <form class="auth-form" @submit.prevent="send()">
        <LabelInput
          @input="(value) => (email = value)"
          :label="lang.emailLabel"
        />
        <div class="auth-card-text">{{ lang.text }}</div>
        <button
          :class="{ disabled: !$validEmail(email) }"
          :disabled="!$validEmail(email)"
          type="submit"
          class="auth-confirm-btn"
        >
          {{ lang.confirmBtn }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
const verifyTypes = {
  EMAIL: "Email",
  SMS: "SMS",
  GOOGLE_AUTHENTICATOR: "GoogleAuth",
};
export default {
  name: "ForgetPassword",
  data() {
    return {
      lang: this.$languageDict().forgetPassword,
      goto: {
        EMAIL: "/email",
        SMS: "/sms",
        GOOGLE_AUTHENTICATOR: "google-auth",
      },
      email: "",
      emailError: "",
    };
  },
  methods: {
    checkEmail() {
      if (!this.email) {
        this.emailError = "ایمیل اجباری";
      } else if (!this.validEmail(this.email)) {
        this.emailError = "ایمیل صحیح وارد نمایید";
      } else {
        this.emailError = "";
      }
      if (!this.emailError.length) {
        return true;
      }
    },
    validEmail(email) {
      let re = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
      return re.test(email);
    },
    async send() {
      if (this.checkEmail(this.email)) {
        await this.checkEmail();
        this.state.loading = true;
        const res = await this.$axios.post("/users/forget-password", {
          email: this.email,
          authenticationType: "EMAIL",
        });
        this.$cookies.set("username", this.email);
        this.state.userInfo.email = this.email;
        if (res.baseDTO) {
          this.state.userInfo.mobilenumber =
            res.baseDTO.starTwoStepAuthentication || "";
          this.state.userInfo.twoStepAuthenticationType =
            verifyTypes[res.baseDTO.twoStepAuthenticationType];
        } else {
          this.state.userInfo.twoStepAuthenticationType = "Email";
        }
        await this.$router.push({
          name: "ChangePass",
          params: {
            type: this.goto[res.baseDTO.twoStepAuthenticationType],
          },
        });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped lang="scss"></style>
